import { MoreOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { DvmExamOutput } from 'gql/types';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

type PropTypes = {
  dvmExam: DvmExamOutput;
  removeHandler: () => void;
  updateHandler: (dvmExam: DvmExamOutput) => void;
};

const ActionsCell: FC<PropTypes> = ({
  dvmExam,
  removeHandler,
  updateHandler,
}) => {
  const { t } = useTranslation('donor.DvmExamTable.ActionsCell');
  const currentUser = useCurrentUser();

  // TODO: Implement permissions logic later
  //   const canDeleteDvmExamData = currentUser.isCan(
  //     PermissionsEnum.DeleteDvmExamData
  //   );
  //   const canUpdateDvmExamData = currentUser.isCan(
  //     PermissionsEnum.UpdateDvmExamData
  //   );
  const canDeleteDvmExamData = true;
  const canUpdateDvmExamData = true;

  const editMenuOptions = canUpdateDvmExamData
    ? {
        label: t('editDvmExam'),
        key: 'edit-dvmExam',
        onClick: () => updateHandler(dvmExam),
      }
    : undefined;
  const removeMenuOption = canDeleteDvmExamData
    ? {
        label: t('deleteDvmExam'),
        key: 'delete',
        onClick: removeHandler,
      }
    : undefined;
  const menuOptions = [editMenuOptions, removeMenuOption] as ItemType[];

  return (
    <Dropdown trigger={['click']} overlay={<Menu items={menuOptions} />}>
      <MoreOutlined className={styles.moreIcon} />
    </Dropdown>
  );
};

export default ActionsCell;
